import { BaseGraphQL } from "~/services/baseGraphQL";
import { GRAPHQL_AUTHENTICATION } from "~/constants/url";
import { JsonResponseType } from "~/types/jsonResponseType";
import { ResetPasswordInput } from "../types/confirmResetPassword";

const authenticationGraph = BaseGraphQL({
  baseUrl: GRAPHQL_AUTHENTICATION,
});

export const confirmResetPassword = async (input: ResetPasswordInput) => {
  const query = `
      mutation($input: ResetPasswordInput) {
      authenticate {
        confirmResetPassword(resetPasswordVM: $input) {
          messageCode
          succeed
          data {
            id
          }
        }
      }
    }
  `;

  return await authenticationGraph<
    { succeed: boolean; messageCode: string },
    {
      authenticate: {
        confirmResetPassword: JsonResponseType<{
          succeed: boolean;
          messageCode: string;
        }>;
      };
    }
  >(
    {
      action: "UserGraphQL",
      query,
      variables: { input },
    },
    (input) => input.authenticate.confirmResetPassword,
  );
};
